function CancellationPolicy() {
	return (
		<div className="cancellationPolicyContainer">
			<p className="cancellationPolicyTitle tag visionCardTag">
				Cancellations, No-shows, and Late Arrivals
			</p>
			<p className="cancellationPolicyText">
				A <b>24-hour notice</b> for appointment cancellations to avoid incurring
				a cancellation fee is required. Clients are responsible for the payment
				of cancellation fees if appointments are cancelled within 24 hours of
				the scheduled time. <br /> <br /> Clients that do not show up for their
				appointment schedule will be considered a <b>no-show</b> and will be
				<b> charged the full rate</b>. If you arrive late, your session will be
				adjusted based on the remaining time. <br />
				<br /> We acknowledge that life can be unpredictable, with unexpected
				obligations. We appreciate your cooperation in notifying us if you need
				to cancel, reschedule, or if you anticipate being late.
			</p>
		</div>
	);
}

export default CancellationPolicy;
